import { useState } from 'react';
import { motion } from 'framer-motion';
import { Menu, X, ScanBarcode } from 'lucide-react';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navLinks = [
    { name: 'Features', href: '#features' },
    { name: 'How it Works', href: '#how-it-works' },
    { name: 'Pricing', href: '#pricing' },
    { name: 'FAQ', href: '#faq' },
  ];

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
      className="bg-white/70 backdrop-blur-xl border-b border-white/20 sticky top-0 z-50"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="#" className="flex items-center gap-2" data-testid="navbar-logo">
            <div className="w-10 h-10 bg-brand-primary rounded-xl flex items-center justify-center">
              <ScanBarcode className="w-6 h-6 text-white" />
            </div>
            <span className="font-heading font-black text-2xl text-brand-secondary">
              Grab<span className="text-brand-primary">Pe</span>
            </span>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="text-neutral-text-secondary font-medium hover:text-brand-primary transition-colors duration-200"
                data-testid={`nav-link-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
              >
                {link.name}
              </a>
            ))}
          </div>

          {/* CTA Buttons */}
          <div className="hidden md:flex items-center gap-4">
            <a
              href="#contact"
              className="text-brand-primary font-semibold hover:text-brand-primary-hover transition-colors"
              data-testid="nav-login-btn"
            >
              Log in
            </a>
            <a
              href="#contact"
              className="bg-brand-primary hover:bg-brand-primary-hover text-white rounded-full px-6 py-3 font-bold shadow-[0_4px_14px_0_rgba(99,91,255,0.39)] transition-all hover:scale-105 active:scale-95"
              data-testid="nav-get-started-btn"
            >
              Get Started
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 text-brand-secondary"
            data-testid="mobile-menu-btn"
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden pb-6"
          >
            <div className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  className="text-neutral-text-secondary font-medium hover:text-brand-primary transition-colors py-2"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {link.name}
                </a>
              ))}
              <div className="flex flex-col gap-3 pt-4 border-t border-neutral-border">
                <a
                  href="#contact"
                  className="text-brand-primary font-semibold text-center py-2"
                >
                  Log in
                </a>
                <a
                  href="#contact"
                  className="bg-brand-primary hover:bg-brand-primary-hover text-white rounded-full px-6 py-3 font-bold text-center shadow-[0_4px_14px_0_rgba(99,91,255,0.39)]"
                >
                  Get Started
                </a>
              </div>
            </div>
          </motion.div>
        )}
      </div>
    </motion.nav>
  );
};

export default Navbar;
